<!--
  NetworkStatusIndicatorComponent
  NORMAL state: vm.visible = false → nothing rendered at all.
  All other states: pill appears with icon + label.
-->
<div
  *ngIf="vm && vm.visible"
  class="network-pill"
  [class]="vm.cssClass"
  [class.pulsing]="vm.pulsing"
  [title]="'Network: ' + vm.state"
  aria-live="polite"
  [attr.aria-label]="'Network status: ' + vm.label"
>
  <i [class]="vm.icon + ' network-icon'"></i>
  <span class="network-label">{{ vm.label }}</span>
</div>
